'use strict';

var RuleListingController = function RuleListingController($scope, $window, strategyConstants, configurationService, gridStatusCustomRenderersFactory, saveRuleService, dataService, featureToggleService) {
  $scope.PANEL_TYPE = strategyConstants.PANEL_TYPE;
  $scope.statusScenarioEventName = 'status-scenario-tooltip';
  $scope.rulesStatusEventName = 'rules-status';
  $scope.customRenderers = gridStatusCustomRenderersFactory;
  $scope.segmentClassControlIsEnabled = featureToggleService.isEnabled('SEGMENT_CLASS_CONTROL');
  $scope.launchSsiLink = function () {
    //Open SSI Inventory Analyzer
    var ssiUrl = configurationService.getSsiUrl() + '?carrier=' + configurationService.getHostCarrier() + '&page=Rules';
    $window.open(ssiUrl);
  };
  $scope.saveRuleStatus = function (event, data, newStatus) {
    dataService.clearCache();
    saveRuleService.getRuleById(data.technicalId).then(function (response) {
      var ruleToUpdate = response.detailedRules[0];
      ruleToUpdate.status = newStatus;
      if (ruleToUpdate.isQuickRule === false) {
        ruleToUpdate.strategies = undefined;
      }
      saveRuleService.updateRule(ruleToUpdate).then(function () {
        $scope.$broadcast('grid:dataChanged');
      });
    });
  };
};
RuleListingController.$inject = ['$scope', '$window', 'StrategyConstants', 'ConfigurationService', 'GridStatusCustomRenderersFactory', 'SaveRuleService', 'DataService', 'FeatureToggleService'];
module.exports = RuleListingController;